import React, { useEffect, useState } from "react";
import { Col, Modal, Table, Tag, Typography } from "antd";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { useGetInvites } from "../ServerSideStates";
import { MazakaButton } from "apps/Common/MazakaButton";
import UpdateInviteStatus from "./UpdateInviteStatus";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import useWindowSize from "helpers/useWindowSize";
import { EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

const ListItems = () => {
  const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
  const [isShowUpdateStatusModal, setIsShowUpdateStatusModal] = useState(false);
  const queryClient = useQueryClient();
  const { filter } = useSelector((state: RootState) => state.invite);
  const windowSize = useWindowSize();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    if (windowSize.width < 1040) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  }, []);

  const columns = [
    {
      title: "Adı Soyadı",
      dataIndex: "invitationSenderFullName",
      render: (value: string, record: any) => {
        return (
          <>
            <div className="!flex !flex-col !gap-1">
              <div>
                <Text >
                  {value}
                </Text>
              </div>
              <div className="!flex !flex-col !gap-1 xl:!hidden">
                <div>
                  <Text className="!text-indigo-500 ">
                    {record?.invitationSenderPhoneNumber || ""}
                  </Text>
                </div>
                <div>
                  <Text className="!text-indigo-500 ">
                    {record?.invitationSenderEmail || ""}
                  </Text>
                </div>
                <div className="!flex !flex-col gap-1 md:!block">
                
                  <span>
                    <Text className="!text-xs" >{record?.store?.storeName || ""}</Text>
                  </span>
                </div>
                <div className="!flex !flex-col md:!block">
         
          <span>
            <Tag
              color={
                record?.invitationStatus === 0
                  ? "blue"
                  : record?.invitationStatus === 1
                  ? "green"
                  : "error"
              }
            >
              {record?.invitationStatus === 0
                ? "Bekliyor"
                : record?.invitationStatus === 1
                ? "Onaylandı"
                : "Reddedildi"}
            </Tag>
          </span>
        </div>
        <div>
        {record?.invitationStatus === 0 && (
              <MazakaButton
              icon={<EditOutlined/>}
                  className=" !text-blue-500 !border-none !p-0 !flex gap-1 !text-xs md:!text-sm !bg-transparent"
                onClick={async () => {
                  await setSelectedRecord(record);
                  setIsShowUpdateStatusModal(true);
                }}
              >
                Daveti Güncelle
              </MazakaButton>
            )}
        </div>
              </div>
            </div>
          </>
        );
      },
    },
    ...(isSmallScreen?[]:[


      {
        title: "Telefon",
        dataIndex: "invitationSenderPhoneNumber",
  
        render: (text: string) => {
          return (
            <>
              <Text className="!text-indigo-500 ">{text}</Text>
            </>
          );
        },
      },
      {
        title: "E-Posta",
        dataIndex: "invitationSenderEmail",
        render: (email: string) => {
          return (
            <>
              <Text className="!text-indigo-500 ">{email}</Text>
            </>
          );
        },
      },
  
      {
        title: "Mağazalar",
  
        render: (text: string, record: any) => {
          return (
            <div className="!flex !flex-col gap-1 md:!block">
              <span>
                <Tag color="green">{record?.store?.storeName || ""}</Tag>
              </span>
            </div>
          );
        },
      },
  
      {
        title: "Davet Durumu",
        dataIndex: "invatationStatus",
        key: "invatationStatus",
        render: (status: boolean, record: any) => (
          <div className="!flex !flex-col md:!block">
            <Text className="mobile-label" data-label="Davet Durumu"></Text>
            <span>
              <Tag
                color={
                  record?.invitationStatus === 0
                    ? "blue"
                    : record?.invitationStatus === 1
                    ? "green"
                    : "error"
                }
              >
                {record?.invitationStatus === 0
                  ? "Bekliyor"
                  : record?.invitationStatus === 1
                  ? "Onaylandı"
                  : "Reddedildi"}
              </Tag>
            </span>
          </div>
        ),
      },
  
      {
        title: "",
        dataIndex: "edit",
        key: "edit",
        width: "8%",
        render: (key: any, record: any) => (
          <Col className="!flex justify-end items-center">
            {record?.invitationStatus === 0 && (
              <MazakaButton
                className="!bg-black !text-white "
                onClick={async () => {
                  await setSelectedRecord(record);
                  setIsShowUpdateStatusModal(true);
                }}
              >
                Daveti Güncelle
              </MazakaButton>
            )}
          </Col>
        ),
      },
    ]),

  ];
  const invites = useGetInvites(filter);
  return (
    <>
      <Table
        columns={columns}
        dataSource={invites?.data?.data?.data ? invites?.data?.data?.data : []}
        loading={invites.isLoading || invites.isFetching}
        rowKey={"id"}
        rowClassName="responsive-row"
        pagination={{
          position: ["bottomRight"],
          className: "!px-0",
          // onChange: handleChangePagination,
          total: invites?.data?.data?.length || 0,
          pageSize: 20,
          showLessItems: true,
          size: "small",
          showSizeChanger: true,

          locale: { items_per_page: "" },
          showTotal: (e) => `${e}`,
        }}
      />
      <Modal
        open={isShowUpdateStatusModal}
        footer={false}
        onCancel={() => {
          setIsShowUpdateStatusModal(false);
        }}
      >
        <UpdateInviteStatus
          selectedRecord={selectedRecord}
          onFinish={() => {
            queryClient.resetQueries({
              queryKey: endPoints.getInviteListFilter,
              exact: false,
            });
            setIsShowUpdateStatusModal(false);
          }}
        />
      </Modal>
    </>
  );
};

export default ListItems;
